<!-- src/views/projects/show.vue -->
<template>
  <section class="container">
    <div class="row">
      <div class="col">
        <div class="mb-2 d-sm-flex align-items-center justify-content-between">
          <h2 class="mb-sm-0">{{ $t('page.projects.show_title') }}</h2>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between">
          <div>
            <h3 class="card-title"></h3>
            <p class="card-title-desc"></p>
          </div>
          <div>
            <button class="btn btn-sm btn-primary me-2" id="home" @click.prevent="handleIndex()"
              :title="$t('common.home')">
              <i class="fa fa-home"></i> {{ $t('common.home') }}
            </button>
            <button class="btn btn-sm btn-primary me-2" id="new" @click.prevent="handleCreate()"
              :title="$t('common.new')">
              <i class="fa fa-plus"></i> {{ $t('common.new') }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div v-if="!form" class="text-center">
          <div>Carregando...</div>
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12">
              <span class="input-label">{{ $t('page.projects.inputs.service_id') }}</span> {{ form.service_id }}
            </div>
            <div class="col-12">
              <span class="input-label">{{ $t('page.projects.inputs.name') }}</span> {{ form.name }}
            </div>
            <div class="col-12">
              <span class="input-label">{{ $t('page.projects.inputs.version') }}</span> {{ form.version }}
            </div>

          </div>
        </div>
      </div>
      <div class="card-footer">
      </div>
    </div>
    <div class="row">
      <TabsProjects v-if="form" :form="form" />
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useProjectStore } from '@/stores/projectStore';
import { useI18n } from 'vue-i18n';
import TabsProjects from "@/components/projects/TabsProjects";

const route = useRoute();
const router = useRouter();
const projectStore = useProjectStore();
const { t } = useI18n();
const form = ref({});

// Go to Index
const handleIndex = () => {
  router.push({ name: "projects-index" });
};

// Go to Create
const handleCreate = () => {
  router.push({ name: "projects-create" });
};

// Mounted
onMounted(async () => {
  const projectId = route.params.id;
  const project = await projectStore.getProject(projectId);
  form.value = project;
});
</script>

<style scoped>
.input-label {
  font-weight: bold;
}

.input-label::after {
  content: ':';
}
</style>